import {getField, updateField} from "vuex-map-fields";
import Repository from "@/repository";

const FUEL_REQUISITION_API = "/fuelRequisition";

// ----------------------- STATE ------------------------- //
const state = {
    fuel_requisition_data: [],
    currentIndex: -1,
    selectedFuelRequisitions: [],
};

// ----------------------- GETTERS ----------------------- //
const getters = {
    getFuelRequisition: state => getField(state.fuel_requisition_data[state.currentIndex]),

    getSelectedFuelRequisitions: state => { return state.selectedFuelRequisitions},

    getCurrentFuelRequisitions: state => {
        return state.fuel_requisition_data[state.currentIndex];
    },



    getMetrics: state => {
        return state.metrics;
    },

    getFuelRequisitionsByVehicleID: state => vehicleID => {
        return state.fuel_requisition_data.filter(element => element.vehicle_id == vehicleID)
    },
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
    updateFuelRequisitions(state, payload) {
        updateField(state.fuel_requisition_data[state.currentIndex], payload);
    },

    setSelectedFuelRequisitions(state, payload) {
        state.selectedFuelRequisitions = payload;
    },
    setCurrentIndexByID(state, theID) {
        state.currentIndex = state.fuel_requisition_data.findIndex(fuel_requisition => fuel_requisition.id == theID);
    },

    loadAllFuelRequisitions(state, payload) {
        state.fuel_requisition_data = payload.data.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
        state.currentIndex = 0;
    },

    loadMetrics(state, payload) {
        state.metrics = payload.data;
    },

    addFuelRequisitions(state, payload) {
        state.fuel_requisition_data.push(payload.data);
        state.currentIndex = state.fuel_requisition_data.length - 1;
        state.fuel_requisition_data[state.currentIndex].requisition_date_time = null;
    },

    saveFuelRequisitions(state, payload) {
        state.fuel_requisition_data[state.currentIndex] = payload.data;
    },

    quickApproval(state,payload)  {
        state.fuel_requisition_data.splice(state.currentIndex, 1, payload.data);
        // state.fuel_requisition_data.push(payload.data);
        // state.fuel_requisition_data[state.currentIndex] = payload.data;
    },

    fetchFuelRequisitions(state, payload) {
        if (state.currentIndex == -1) {
            state.fuel_requisition_data.push(payload.data);
            state.currentIndex = 0;
        } else {
            state.fuel_requisition_data[state.currentIndex] = payload.data;
        }
    },

    getFuelStationName(state,payload){
      let fuelStations = payload.data;
        console.log(fuelStations);
      if(fuelStations && fuelStations.length > 0){
          state.fuel_requisition_data[state.currentIndex].fuel_station_name = fuelStations[0].name;
          if(fuelStations[0].street) {
              state.fuel_requisition_data[state.currentIndex].fuel_station_name += ` | ${fuelStations[0].street}`
          }
          state.fuel_requisition_data[state.currentIndex].request_location = fuelStations[0].location;
      }

    },

    deleteFuelRequisitions(state, payload) {
        state.currentIndex = state.fuel_requisition_data.findIndex(
            fuel_requisition => fuel_requisition.id == payload.data.id
        );
        state.fuel_requisition_data.splice(state.currentIndex, 1);
    },
    deleteImage(state, payload) {
        let index = state.fuel_requisition_data[state.currentIndex].photos_id.findIndex(
            item => item === payload
        );

        state.fuel_requisition_data[state.currentIndex].photos_id.splice(index, 1);
        console.log(state.fuel_requisition_data[state.currentIndex].photos_id);
    },

    deleteDocument(state, payload) {
        let index = state.fuel_requisition_data[state.currentIndex].documents_id.findIndex(
            item => item === payload
        );
        state.fuel_requisition_data[state.currentIndex].documents_id.splice(index, 1);
    },

    deleteSelectedFuelRequisitions(state,payload){
        payload.data.forEach(element => {
            let theIndex = state.fuel_requisition_data.findIndex(
                (fuel_requisition) => fuel_requisition.id == element
            );
            state.fuel_requisition_data.splice(theIndex, 1);

        })
        state.selectedFuelRequisitions = [];
    },

    setStatus(state, payload) {
        state.fuel_requisition_data[state.currentIndex].status = payload;
    },

    cleanForSave(state) {
        state.fuel_requisition_data[state.currentIndex].volume = parseFloat(
            state.fuel_requisition_data[state.currentIndex].request_volume
        );
        state.fuel_requisition_data[state.currentIndex].price = parseFloat(
            state.fuel_requisition_data[state.currentIndex].request_cost
        );


        state.fuel_requisition_data[state.currentIndex].vehicle = null;
        state.fuel_requisition_data[state.currentIndex].request_by = null;
        state.fuel_requisition_data[state.currentIndex].merchant = null;

    },
    next(state){
        if(state.currentIndex == state.fuel_requisition_data.length-1){
            state.currentIndex = 0;
        }else{
            state.currentIndex += 1;
        }
    },

    previous(state){
        if(state.currentIndex == 0){
            state.currentIndex = state.fuel_requisition_data.length-1;
        }else{
            state.currentIndex -= 1;
        }
    },
    reset(state) {
        state.fuel_requisition_data = []
        state.currentIndex = -1
        state.selectedFuelRequisitions = []
        state.metrics = null
    }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
    async loadAllFuelRequisitions({commit}) {
        try {
            commit("loadAllFuelRequisitions", await Repository.get(`${FUEL_REQUISITION_API}`));
        } catch (error) {
            console.log(error);
        }
        // try {
        //     commit("loadMetrics", await Repository.get(`${FUEL_REQUISITION_API}/metrics`));
        // } catch (error) {
        //     console.log(error);
        // }
    },

    async quickApproval({state},payload) {

        var requisition =state.fuel_requisition_data[state.currentIndex];

        await Repository.post(`${FUEL_REQUISITION_API}/action?action=${payload.status}&contact_id=${payload.contact_id}`,requisition).then(response => {
            // commit("quickApproval", response);
        }).catch(error => {
            console.log(error);
        })
    },

    // localhost:4000/api/fuelRequisition/action?id=3221ee9a-8f68-4ea5-b34c-f556552f38a7&contact_id=6eafadeb-1061-47e3-9eaa-3ff5c3ccce3c&action=approve

    async addFuelRequisitions({commit}) {
        await Repository.get(`${FUEL_REQUISITION_API}/new`)
            .then(response => {
                commit("addFuelRequisitions", response);
            })
            .catch(error => {
                console.log(error);
            });
    },

    async saveFuelRequisitions({state, commit}) {
        try {
            // commit("cleanForSave");
            console.log(state.fuel_requisition_data[state.currentIndex]);
            commit(
                "saveFuelRequisitions",
                await Repository.post(
                    `${FUEL_REQUISITION_API}`,
                    state.fuel_requisition_data[state.currentIndex]
                )
            );
        } catch (error) {
            console.log(error);
        }
    },

    async fetchFuelRequisitions({commit}, payloadID) {
        try {
            commit("fetchFuelRequisitions", await Repository.get(`${FUEL_REQUISITION_API}/${payloadID}`));
        } catch (error) {
            console.log(error);
        }
    },

    async deleteFuelRequisitions({commit}, payloadID) {
        try {
            commit("deleteFuelRequisitions", await Repository.delete(`${FUEL_REQUISITION_API}/${payloadID}`));
        } catch (error) {
            console.log(error);
        }
    },

    async getFuelStationName({commit},payload) {
        try {

            commit("getFuelStationName", await Repository.get(`/track/getNearFuelStation?vehicle_id=${payload.vehicleID}&time=${payload.time}`));
        }catch (error) {
            console.log(error);
        }
    },

    async deleteSelectedFuelRequisitions({ state,commit }) {
        try {
            let idString = ''
            state.selectedFuelRequisitions.forEach(element => {
                idString += "&id="+element.id
            })
            commit(
                "deleteSelectedFuelRequisitions",
                await Repository.delete(`${FUEL_REQUISITION_API}/deleteSelected?${idString}`)

            );
        } catch (error) {
            console.log(error);
        }
    },

    async searchFuelRequisitions({commit}, searchTerm) {
        try {
            commit(
                "loadAllFuelRequisitions",
                await Repository.get(`${FUEL_REQUISITION_API}/search?q=${searchTerm}`)
            );
        } catch (error) {
            console.log(error);
        }
    }
};
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
